import { Outlet } from 'react-router';

import { DynamicHeader } from '~/components/DynamicHeader';
import Footer from '~/components/Footer';
import useRegion from '~/hooks/useRegion';

export default function MainMenuTemplate() {
  const region = useRegion();

  return (
    <>
      <DynamicHeader region={region} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
